import { useEffect, useState } from 'react';
import Header from '../../components/Header/Header';
import USDUserInfo from '../../components/USDRequests/USDUserInfo';
import USDUserDocs from '../../components/USDRequests/USDUserDocs';
import USDComments from '../../components/USDRequests/USDComments';
// import { Alert } from '@piggytechng/component-library';

const USDRequestDetails = () => {
  // const [, setFilterModal] = useState(false);
  const [activeTab, setActiveTab] = useState('userinfo');
  const [showCommentTab, setShowCommentTab] = useState(false);

  useEffect(() => {
    localStorage.setItem('activeCustomer', '');
  }, []);

  // const handleSubmit = (e: any) => {
  //   e.preventDefault();
  // };

  // const closeModal = (e: any) => {
  //   if (e.target.className === 'filter-modal') {
  //     setFilterModal(false);
  //   }
  // };

  return (
    <>
      <Header name="USD Request Details" backButton />
      <div className="usd-details">
        <div className="tabs-container">
          <div
            className={`tab-buttons ${activeTab === 'userinfo' && 'active-tab'}`}
            onClick={() => {
              setActiveTab('userinfo');
            }}
          >
            User Information
          </div>
          <div
            className={`tab-buttons ${activeTab === 'documents' && 'active-tab'}`}
            onClick={() => setActiveTab('documents')}
          >
            Documents
          </div>
          {showCommentTab && (
            <div
              className={`tab-buttons ${activeTab === 'comments' && 'active-tab'}`}
              onClick={() => setActiveTab('comments')}
            >
              Comments/Feedbacks
            </div>
          )}
        </div>

        {activeTab === 'userinfo' && <USDUserInfo setShowCommentTab={setShowCommentTab} />}
        {activeTab === 'documents' && <USDUserDocs />}
        {activeTab === 'comments' && <USDComments />}
      </div>
    </>
  );
};

export default USDRequestDetails;
